const onChangeListeners = [];

const push = pathname => {
    window.history.pushState({pathname}, '', pathname);

    onChangeListeners.forEach(callback => callback(pathname));
}

const addLocationListener = cb => onChangeListeners.push(cb)
window.onpopstate = e => onChangeListeners.forEach(callback => callback(document.location.pathname))
export {
    push,
    addLocationListener
}



// WEBPACK FOOTER //
// ./src/fm/lib/history.js